import { useState, useRef, useEffect, useCallback } from 'react';
import { ChartUtilResult } from '@/components/General/PlayerChart';
import { Parameter } from '@/pages/InteractiveSimulation/types/replayInteractive';
import { 
	cleanUnselectedParameters, 
	chartDataMapToArray 
} from '@/utils/InteractiveSimulation/chartDataTransformers';


export function useChartDataManager(parameters: Parameter[]) {
	const [chartData, setChartData] = useState<ChartUtilResult[]>([]);
	const chartDataRef = useRef<Map<number, ChartUtilResult>>(new Map());


	useEffect(() => {
		const hasChanges = cleanUnselectedParameters(parameters, chartDataRef.current);
		
		if (hasChanges) {
			setChartData(chartDataMapToArray(chartDataRef.current));
		}
	}, [parameters]);


	const updateChartData = useCallback(() => {
		setChartData(chartDataMapToArray(chartDataRef.current));
	}, []);


	const clearChartData = useCallback(() => {
		chartDataRef.current.clear();
		setChartData([]);
	}, []);


	const getChartDataMap = useCallback(() => chartDataRef.current, []);

	return {
		chartData,
		chartDataMap: chartDataRef.current,
		updateChartData,
		clearChartData,
		getChartDataMap,
	};
}
